<template>
  <card class="commands-list custom-header">
    <div slot="header" class="card-text">
      <h4 class="card-title">
        {{ card.title }}
      </h4>
    </div>
    <div v-if="card.alias !== 'marathon-activate'" class="commands-list-content">
      <div class="commands-list custom-scroll">
        <el-table
          v-loading="loading"
          :data="commands"
          element-loading-background="rgba(255, 255, 255, 0.6)"
          :empty-text="loading ? 'Загрузка команд...' : 'Команды на найдены'">
          <el-table-column>
            <template #default="props">
              <div>
                {{ props.row['description'] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="140">
            <template #default="props">
              <p-button
                type="info"
                :disabled="!!executeCommand"
                @click="handleRunCommand(props.row)">
                <el-icon v-if="executeCommand === props.row.command" class="is-loading">
                  <Loading/>
                </el-icon>
                <span v-else>
                  Выполнить
                </span>
              </p-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <marathon-card v-else/>
  </card>
</template>

<script>
import { mapActions } from "vuex";
import MarathonCard from '@/components/Pages/Settings/MarathonActivationCard'

export default {
  name: "CommandCard",
  components: {
    MarathonCard
  },
  props: {
    card: Object,
    commands: Array
  },
  data() {
    return {
      executeCommand: undefined
    }
  },
  computed: {
    loading() {
      return !this.commands
    }
  },
  methods: {
    ...mapActions({
      runCommand: 'superadministrator/runCommand'
    }),
    async handleRunCommand(btn) {
      this.executeCommand = btn.command
      await this.runCommand(btn.command)
      this.executeCommand = undefined
    }
  }
}
</script>

<style scoped>

</style>
